import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
import { useQuery } from '@tanstack/react-query';
import getFetchAdobeTargetOptions from './get-options';
import { getIsAdobeTargetEnabled } from './utils';

/**
 * @name useAdobeTarget
 * @description Hook to fetch Adobe Target experience data
 * @param {Object} params - Parameters
 * @param {string} params.activityName - Name of the activity, must match the activity's name in Adobe Target
 * @param {string[]} params.experiences - Array of experience names that can be returned in `experience` return field ['A', 'B', 'C', etc...]
 * @param {string} params.locationName - Location name (mbox) for the Target request (e.g. 'cart_page', 'cartux_mini_bag').
 *
 * @returns {Object} adobeTargetData
 * @returns {string} adobeTargetData.experience - experience that is selected by Target or internal logic to render
 * @returns {boolean} adobeTargetData.isLoading - indicates if the Target query is loading
 *
 **/

var useAdobeTarget = function useAdobeTarget(_ref) {
  var activityName = _ref.activityName,
    experiences = _ref.experiences,
    locationName = _ref.locationName;
  // Development-only validation for experiences array
  if (process.env.NODE_ENV === 'development') {
    Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./validate-experiences'));
    }).then(function (_ref2) {
      var validateExperiences = _ref2["default"];
      validateExperiences(experiences);
    });
  }
  var _useQuery = useQuery(_objectSpread({
      enabled: getIsAdobeTargetEnabled()
    }, getFetchAdobeTargetOptions({
      locationName: locationName
    }))),
    data = _useQuery.data,
    isLoading = _useQuery.isLoading,
    isSuccess = _useQuery.isSuccess;
  var CONTROL_EXPERIENCE = {
    experience: 'A',
    isLoading: isLoading
  };
  if (!getIsAdobeTargetEnabled()) {
    return CONTROL_EXPERIENCE;
  }
  if (isLoading) {
    return {
      experience: null,
      isLoading: isLoading
    };
  }
  if (isSuccess) {
    if ((data === null || data === void 0 ? void 0 : data.activityName) === activityName) {
      var experienceName = data === null || data === void 0 ? void 0 : data.experienceName;

      // Validate that the experience name from Adobe Target is in the experiences array
      if (experiences !== null && experiences !== void 0 && experiences.includes(experienceName)) {
        return {
          experience: experienceName,
          isLoading: isLoading
        };
      }
    }
  }
  return CONTROL_EXPERIENCE;
};
export default useAdobeTarget;